"use strict";
/**
 * @module Services.Metrics
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A request for entity metrics from a certain server of the cluster.
 */
var MeasuredEntityClassRequest = /** @class */ (function () {
    function MeasuredEntityClassRequest(entityClass, serverName) {
        this.entityClass = entityClass;
        this.serverName = serverName;
    }
    return MeasuredEntityClassRequest;
}());
exports.MeasuredEntityClassRequest = MeasuredEntityClassRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/metrics/measured-entity-class-request.js
// module id = 841
// module chunks = 1